<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col :cols="12" :xs="12" :sm="8" :md="4" :lg="4">
          <v-card class="elevation-1 pa-3">
            <div class="d-flex justify-space-between">
              <v-card-title class="mt-4">
                <img :src="logoPath" alt="ЭТП" height="60"/>
                <v-spacer />{{ $t('Регистрация') }}</v-card-title>
              <v-btn class="mr-4 mt-4" color="primary" density="comfortable" variant="outlined" @click="close">{{ $t('Вход') }}</v-btn>
            </div>
            <v-card-text>
              <v-divider/>
              <v-form ref="form">
                <v-card-subtitle class="pl-0 mt-4 mb-4">{{ $t('Данные организации') }}</v-card-subtitle>
                <v-row>
                  <v-col cols="12">
                    <v-radio-group
                      inline
                      v-model="contragent.type"
                    >
                      <v-radio :label="$t('Является организатором')" :value="ORGANIZER" />
                      <v-radio :label="$t('Является участником')" :value="SUPPLIER" />
                    </v-radio-group>
                    <Input
                      ref="contragentInnRef"
                      label="CRN"
                      placeholder="Введите CRN"
                      v-model="contragent.inn"
                      v-mask="masks.inn"
                      :rules="rules.crn"
                      :disabled="loading"
                      class="text-body-2"
                      required
                    />
                    <Input
                      label="Наименование организации"
                      placeholder="Введите наименование организации"
                      v-model="contragent.fullName"
                      :rules="rules.fullName"
                      :disabled="loading"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <Input
                      label="Телефон"
                      placeholder="Введите телефон"
                      v-model="contragent.phone"
                      :rules="rules.phone"
                      :disabled="loading"
                      class="text-body-2"
                    />
                    <Input
                      label="Адрес электронной почты"
                      placeholder="Введите адрес электронной почты"
                      v-model="contragent.email"
                      :rules="rules.email"
                      :disabled="loading"
                      class="text-body-2"
                    />
                  </v-col>
                </v-row>
                <v-divider />
                <v-card-subtitle class="pl-0 mt-4 mb-4">{{ $t('Данные пользователя') }}</v-card-subtitle>
                <v-row>
                  <v-col cols="4">
                    <Input
                      label="Фамилия"
                      placeholder="Введите фамилию"
                      v-model="user.lastName"
                      :rules="[].concat(validation.required(), validation.text(255))"
                      :disabled="loading"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                  <v-col cols="4">
                    <Input
                      label="Имя"
                      placeholder="Введите имя"
                      v-model="user.firstName"
                      :rules="[].concat(validation.required(), validation.text(255))"
                      :disabled="loading"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                  <v-col cols="4">
                    <Input
                      label="Отчество"
                      placeholder="Введите отчество"
                      v-model="user.middleName"
                      :rules="validation.text(255)"
                      :disabled="loading"
                      class="text-body-2"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <Input
                      label="Адрес электронной почты"
                      placeholder="Введите адрес электронной почты"
                      v-model="user.email"
                      :rules="[].concat(rules.email, validation.required())"
                      :disabled="loading"
                      :error-messages="errors['user.email']"
                      @blur="checkIfExists($event.target.value, 'email')"
                      @input="errors['user.email'] = null"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                  <v-col cols="6">
                    <Input
                      label="Телефон"
                      placeholder="Введите номер телефона"
                      v-model="user.phone"
                      :rules="[].concat(rules.phone, validation.required())"
                      :disabled="loading"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <Input
                      label="Логин"
                      placeholder="Введите логин"
                      autocomplete="username"
                      v-model="user.username"
                      :rules="[].concat(validation.required(), validation.text(255))"
                      :disabled="loading"
                      :error-messages="errors['user.username']"
                      @blur="checkIfExists($event.target.value, 'username')"
                      @input="errors['user.username'] = null"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <Input
                      label="Пароль"
                      placeholder="Введите пароль"
                      autocomplete="new-password"
                      v-model="user.password"
                      :rules="[].concat(getPasswordRules())"
                      :hide-details="isActivePasswordPolicy"
                      :disabled="loading"
                      :type="showPassword ? 'text' : 'password'"
                      :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append-inner="showPassword = !showPassword"
                      class="text-body-2"
                      required
                    />
                    <div v-if="isActivePasswordPolicy">
                      <span v-for="rule in passwordRules" :class="rule.class">{{rule.text}}</span>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <Input
                      label="Подтверждение пароля"
                      placeholder="Подтвердите пароль"
                      v-model="user.confirmPassword"
                      :rules="[].concat(
                        validation.required(),
                        validation.text(255),
                        validation.equal(user.password, 'Пароли не совпадают')
                      )"
                      :disabled="loading"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      :append-inner-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append-inner="showConfirmPassword = !showConfirmPassword"
                      class="text-body-2"
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="accept"
                      :disabled="loading"
                      class="mb-0 mt-0"
                    >
                      <template v-slot:label>
                        <span>{{ $t('Я даю свое согласие на обработку моих персональных данных в соответствии с законом 152-ФЗ «О персональных данных» от 27.07.2006, согласно прилагаемой') }}
                          <a v-if="personalPolicyFileId" target="_blank" :href="getConfigFileUrl(personalPolicyFileId)">{{ $t('форме') }}</a>
                          <span v-else>{{ $t('форме') }}</span>.</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="regulationEtpFileId">
                  <v-col cols="12">
                    <v-checkbox
                      v-model="acceptReg"
                      :disabled="loading"
                      class="mb-0 mt-0"
                    >
                      <template v-slot:label>
                        <span>{{ $t('Я подтверждаю, что ознакомлен(а) и присоединяюсь к') }}<a target="_blank" :href="getConfigFileUrl(regulationEtpFileId)">{{ $t('Регламенту электронной торговой площадки') }}</a>{{ $t(', действующему на момент регистрации.') }}</span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                density="comfortable"
                variant="outlined"
                :disabled="buttonsDisabled"
                :loading="loading"
                @click="close"
              >{{ $t('Отмена') }}</v-btn>
              <v-btn
                color="primary"
                density="comfortable"
                variant="elevated"
                :disabled="buttonsDisabled"
                :loading="loading"
                @click="doRegister"
              >{{ $t('Зарегистрироваться') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { toast } from '@/lib/toast';
import validation from '@/components/validation';
import api from '@/api';
import { useEditContragent, useHardPasswordRules} from "@/lib/composable";
import Input from "@intec/vue-components/form/Input.vue";
import {validate} from "@babel/core/lib/config/validation/options";
import Config from "@/config";

export default {
  components: {Input},
  setup() {
    const isActivePasswordPolicy = Config.getConfig('PASSWORD_POLICY')?.value;
    const personalPolicyFileId = Config.getConfig('PERSONAL_POLICY')?.value;
    const regulationEtpFileId = Config.getConfig('REGULATION_ETP')?.value;
    const { SUPPLIER, ORGANIZER, contragent, rules, masks, contragentInnRef } = useEditContragent();
    const { validatePassword, passwordRules } = useHardPasswordRules();
    return { SUPPLIER, ORGANIZER, contragent, rules, masks, contragentInnRef, validatePassword, passwordRules,
      isActivePasswordPolicy, personalPolicyFileId, regulationEtpFileId };
  },
  data() {
    return {
      user: {
        lastName: null,
        firstName: null,
        middleName: null,
        email: null,
        phone: null,
        username: null,
        password: null,
        confirmPassword: null,
        type: null,
      },
      errors: {
        'user.email': null,
        'user.username': null
      },
      loading: false,
      buttonsDisabled: false,
      showPassword: false,
      showConfirmPassword: false,
      accept: false,
      acceptReg: false,
      validation,
      logoPath: this.$themeData.logoPath,
    };
  },
  methods: {
    validate,
    getPasswordRules() {
      return this.isActivePasswordPolicy ? this.validatePassword()
        : [].concat(validation.required(), validation.text(255));
    },
    close() {
      this.$router.push({name: 'login'});
    },
    isValidRecheckedFields() {
      return !this.errors['user.email'] && !this.errors['user.username'];
    },

    async doRegister() {
      if (!this.accept) {
        toast.error('Необходимо дать согласие на обработку персональных данных!');
        return false;
      }
      if(!this.acceptReg && this.regulationEtpFileId > 0) {
        toast.error('Для завершения регистрации необходимо подтвердить ознакомление с Регламентом электронной торговой площадки.');
        return false;
      }
      if (this.isValidRecheckedFields() && (await this.$refs.form.validate()).valid) {
        try {
          this.loading = true;
          this.user.type = this.contragent.type;
          let formData = new FormData();
          formData.append(
            'data',
            JSON.stringify({
              user: this.user,
              contragent: this.contragent,
            }),
          );
          await api.post('/auth/registration', formData);
          this.buttonsDisabled = true;
          toast.info('Вы успешно ввели данные!');

          setTimeout(() => {
            this.close();
          }, 2000);
        } catch (e) {
          toast.error(e.message);
        } finally {
          this.loading = false;
        }
      } else {
        toast.error('Заполните обязательные поля');
      }
    },
    async checkIfExists(value, type) {
      let formData = new FormData();
      formData.append('data', JSON.stringify({ value, type }));
      try {
        await api.post('/auth/checkIfExists', formData);
        this.errors[`user.${type}`] = null;
      } catch (e) {
        toast.error(e.message);
        this.errors[`user.${type}`] = e.message;
      }
    },
    getConfigFileUrl(configFileId) {
      return '/admin/configs/file/' + configFileId;
    }
  },
}
</script>
